import { createPartyRequest } from './helper';
export const getPartiesRecent = createPartyRequest({
    route: '/party/parties/recent',
    method: 'get',
    source: 'data',
});
